import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

export const isToggleSelectionKey = (
  e: ReactKeyboardEvent | KeyboardEvent,
): boolean => e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
